import axios from './axios';

import auth from '../resources/Auth';

const API_URL = process.env.REACT_APP_API_URL;

export default {
  all: async () => {
    const url = `${API_URL}/rentalReservation`;

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  saveReservation: async (body) => {
    const url = `${API_URL}/rentalReservation`;

    return await axios.post(
      url,
      { ...body },
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },

  availability: async (deviceId, date, duration) => {
    const url = `${API_URL}/rentalReservation/availability/${deviceId}?date=${date}&duration=${duration}`;

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  availableDates: async (body) => {
    const url = `${API_URL}/rentalReservation/availableDates`;

    return await axios.post(
      url,
      { ...body },
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },

  cancel: async (id) => {
    const url = `${API_URL}/rentalReservation/${id}/cancel`;

    return await axios.delete(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },
};
